
import './select_media_from_library.less';

import React from 'react';
import map from 'lodash/map';

import SelectMediaAsBackboneModelsFromLibraryModal from './select_media_as_backbone_models_from_library.jsx';

const SelectMediaFromLibraryModal = ({ onAssetsSelect, ...props })=>
  <SelectMediaAsBackboneModelsFromLibraryModal 
    {...props}
    onAssetsSelect={(assets)=> { onAssetsSelect(map(assets, (asset)=> asset.toJSON())); }}
  />;

export default SelectMediaFromLibraryModal;
